// Captures where a visitor came from — AI assistants (ChatGPT, Claude, Perplexity…),
// search engines, social, ad campaigns or direct — once per browser session, and
// returns the fields every lead form attaches so the admin overview can show origin.

const AI = [
  ["chatgpt.com", "ChatGPT"],
  ["openai.com", "ChatGPT"],
  ["claude.ai", "Claude"],
  ["anthropic.com", "Claude"],
  ["perplexity.ai", "Perplexity"],
  ["gemini.google.com", "Gemini"],
  ["copilot.microsoft.com", "Copilot"],
  ["grok.com", "Grok"],
  ["chat.mistral.ai", "Mistral"],
  ["deepseek.com", "DeepSeek"],
];

const SEARCH = [
  ["google.", "Google"],
  ["bing.com", "Bing"],
  ["duckduckgo.com", "DuckDuckGo"],
  ["ecosia.org", "Ecosia"],
  ["search.brave.com", "Brave"],
  ["startpage.com", "Startpage"],
];

const SOCIAL = [
  ["linkedin.com", "LinkedIn"],
  ["facebook.com", "Facebook"],
  ["instagram.com", "Instagram"],
  ["x.com", "X"],
  ["twitter.com", "X"],
  ["wa.me", "WhatsApp"],
  ["t.me", "Telegram"],
  ["reddit.com", "Reddit"],
  ["youtube.com", "YouTube"],
];

const _match = (host, table) => table.find(([domain]) => host.includes(domain));

export const computeLeadSource = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = params.get("utm_source") || params.get("utm_campaign") || "";
    const ref = document.referrer || "";
    let host = "";
    try {
      host = new URL(ref).hostname.replace(/^www\./, "");
    } catch {
      host = "";
    }
    const landing = `${window.location.pathname}${window.location.search}`.slice(0, 300);

    if (utm) {
      return { source: `Campaign · ${utm}`, referring_url: ref, landing_page: landing, utm: params.toString().slice(0, 300) };
    }
    if (host) {
      const ai = _match(host, AI);
      if (ai) return { source: `AI · ${ai[1]}`, referring_url: ref, landing_page: landing, utm: "" };
      const se = _match(host, SEARCH);
      if (se) return { source: `Search · ${se[1]}`, referring_url: ref, landing_page: landing, utm: "" };
      const so = _match(host, SOCIAL);
      if (so) return { source: `Social · ${so[1]}`, referring_url: ref, landing_page: landing, utm: "" };
      if (!host.endsWith("verdecapital.eu")) {
        return { source: `Referral · ${host}`, referring_url: ref, landing_page: landing, utm: "" };
      }
    }
    return { source: "Direct / typed", referring_url: ref, landing_page: landing, utm: "" };
  } catch {
    return { source: "", referring_url: "", landing_page: "", utm: "" };
  }
};

// Call once when the site loads: the FIRST landing of the session is the true origin.
export const captureLeadSource = () => {
  try {
    if (!sessionStorage.getItem("vc_lead_source")) {
      sessionStorage.setItem("vc_lead_source", JSON.stringify(computeLeadSource()));
    }
  } catch {
    /* storage unavailable — forms fall back to computing live */
  }
};

export const leadSourceFields = () => {
  try {
    const raw = sessionStorage.getItem("vc_lead_source");
    return raw ? JSON.parse(raw) : computeLeadSource();
  } catch {
    return { source: "", referring_url: "", landing_page: "", utm: "" };
  }
};
